// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__TIkNk","spinner":"Loading_spinner__UV4+c","spinnerRing":"Loading_spinnerRing__r6qQO","text":"Loading_text__eVYTZ"};